import React from 'react';
import { Avatar } from 'baseui/avatar';
import { IDummyProps } from './types';
import { overrides as customOverrides } from './overrides';
import { mergeOverrides, useStyletron } from 'baseui';
import { Overrides } from 'baseui/overrides';
import { Theme } from '../../Themes/themeProvider/ThemeProvider';

export const View = (props: IDummyProps, ref: any) => {
	const [, theme] = useStyletron();
	const tt: typeof Theme = theme;
	const { overrides, size = tt.avatar.size, ...rest } = props;

	const getFirstAndLastName = (name: string) => {
		const nameArr = name.split(' ');
		if (nameArr.length > 1) {
			return nameArr[0] + ' ' + nameArr[nameArr.length - 1];
		}
		return name;
	};

	return (
		<Avatar
			{...rest}
			size={size}
			ref={ref}
			overrides={
				overrides ? mergeOverrides(customOverrides(props), overrides as Overrides<any>) : customOverrides(props)
			}
			name={getFirstAndLastName(props.name)}
		/>
	);
};
